export default "__VITE_ASSET__P3MTOe54__"